class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  async renderContents(parsedState) {
    const item = parsedState.items ? parsedState.items[0] : parsedState;
    if (!item || !item.key || parsedState.status >= 400) return;
    if (this.lastRenderedKey === item.key && Date.now() - this.lastRenderedAt < 700) return;
    const ticket = this.renderTicket = (this.renderTicket || 0) + 1;
    this.cartItemKey = item.key;
    const sections = this.getSectionsToRender();
    let html = parsedState.sections || {};
    if (sections.some(section => !html[section.id])) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', sections.map(section => section.id).join(','));
        const response = await fetch(url.toString(), {headers: {Accept: 'application/json'}});
        if (!response.ok) return;
        html = await response.json();
      } catch (error) { return; }
    }
    if (ticket !== this.renderTicket) return;
    for (const section of sections) {
      const target = document.getElementById(section.id);
      if (!target || !html[section.id]) continue;
      const doc = new DOMParser().parseFromString(html[section.id], 'text/html');
      const source = doc.querySelector(section.selector || '.shopify-section');
      if (source) target.innerHTML = source.innerHTML;
    }
    if (!document.getElementById('cart-notification-product').textContent.trim()) return;
    this.lastRenderedKey = item.key;
    this.lastRenderedAt = Date.now();
    this.setActiveElement(document.activeElement);
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

(() => {
  if (window.fzCartConfirmationBridge) return;
  window.fzCartConfirmationBridge = true;
  const isAdd = (url, method) => {
    try {
      const parsed = new URL(url, location.href);
      return parsed.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(parsed.pathname) && String(method || 'GET').toUpperCase() === 'POST';
    } catch (error) { return false; }
  };
  const confirm = data => {
    if (!data || data.status >= 400 || !(data.key || data.items?.[0]?.key)) return;
    setTimeout(() => {
      const notification = document.querySelector('cart-notification');
      if (notification) notification.renderContents(data);
    }, 100);
  };
  const originalFetch = window.fetch;
  window.fetch = function(input, options) {
    const add = isAdd(typeof input === 'string' || input instanceof URL ? input : input.url, options?.method || input?.method);
    return originalFetch.apply(this, arguments).then(response => {
      if (add && response.ok) response.clone().json().then(confirm).catch(() => {});
      return response;
    });
  };
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.fzCartAddRequest = isAdd(url, method);
    return originalOpen.apply(this, arguments);
  };
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    if (this.fzCartAddRequest) this.addEventListener('load', () => {
      if (this.status < 200 || this.status >= 300) return;
      try { confirm(this.responseType === 'json' ? this.response : JSON.parse(this.responseText)); } catch (error) {}
    }, {once: true});
    return originalSend.apply(this, arguments);
  };
})();
